import { redirect } from '@tanstack/react-router';
import type { ApiError } from '@/lib/api';
import { clearImpersonation, getImpersonation, impersonationEndFromDetails } from '@/lib/impersonation';

/**
 * A 401 while CoreUp staff are viewing the shop means the view-as-shop token is over (expired, ended, revoked) —
 * not that the shop's own login is missing. Returns the redirect to the "session over" notice (and drops the dead
 * token), or `null` when this is an ordinary session and the caller should send the user to /sign-in.
 */
export function impersonationEndedRedirect(error: ApiError): ReturnType<typeof redirect> | null {
  if (!getImpersonation()) return null;
  clearImpersonation();
  return redirect({ to: '/impersonate', search: { ended: impersonationEndFromDetails(error.details) } });
}
